var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
(() => {
    angular
        .module('QMC.Arbeitszeitnachweis')
        .config(routes);
    routes.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, $urlRouterProvider, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        $stateProvider
            .state('azn', {
            url: '/azn',
            templateUrl: qmcBase + '/Arbeitszeitnachweis',
            controller: 'ArbeitszeitnachweisListController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: AZN.LIST');
                    }]
            }
        })
            .state('aznnew', {
            url: '/azn/new',
            templateUrl: qmcBase + '/Arbeitszeitnachweis/New',
            controller: 'ArbeitszeitnachweisNewController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: AZN.NEW');
                    }]
            }
        })
            .state('azndetail', {
            url: '/azn/detail/:id',
            templateUrl: qmcBase + '/Arbeitszeitnachweis/New',
            controller: 'ArbeitszeitnachweisNewController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current state: AZN.DETAIL');
                    }]
            }
        })
            .state('aznoverview', {
            url: '/azn/overview',
            templateUrl: qmcBase + '/Arbeitszeitnachweis/Overview',
            controller: 'ArbeitszeitnachweisOverviewController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current state: AZN Overview');
                    }]
            }
        })
            .state('manualovertime', {
            url: '/manualovertime',
            templateUrl: qmcBase + '/Arbeitszeitnachweis/ManualOvertime',
            controller: 'ManualOvertimeListController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: ManualOvertime');
                    }]
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var Arbeitszeitnachweis;
    (function (Arbeitszeitnachweis) {
        class HttpProvider {
            static configureHttpProvider($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            }
        }
        Arbeitszeitnachweis.HttpProvider = HttpProvider;
    })(Arbeitszeitnachweis = QMC.Arbeitszeitnachweis || (QMC.Arbeitszeitnachweis = {}));
})(QMC || (QMC = {}));
(() => {
    angular.module('QMC.Arbeitszeitnachweis')
        .config(['$httpProvider', QMC.Arbeitszeitnachweis.HttpProvider.configureHttpProvider]);
})();
var QMC;
(function (QMC) {
    var Arbeitszeitnachweis;
    (function (Arbeitszeitnachweis) {
        class TimeTrackingConstants {
        }
        TimeTrackingConstants.TIME_TRACKING_STAMP_IN = '829F4DFB-F4E0-4921-8AC1-8C4F83952593';
        TimeTrackingConstants.TIME_TRACKING_STAMP_OUT = '04C5C2E9-1485-4466-BF46-DE4428DD3DA7';
        Arbeitszeitnachweis.TimeTrackingConstants = TimeTrackingConstants;
    })(Arbeitszeitnachweis = QMC.Arbeitszeitnachweis || (QMC.Arbeitszeitnachweis = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Arbeitszeitnachweis;
    (function (Arbeitszeitnachweis) {
        let AznwService = class AznwService extends QMC.Common.BaseService {
            constructor($http, $q) {
                super($http, $q);
                this.$http = $http;
                this.$q = $q;
                this.modulePath = '/Arbeitszeitnachweis';
            }
            getArbeitszeitnachweisRequiredFields() {
                return super.getItem(this.modulePath + '/RequiredFields', {}, (data) => {
                    return data;
                });
            }
            getArbeitszeitnachweisList(dateFrom, dateTo, page = -1, pageSize = -1) {
                return super.getPagination(this.modulePath, { dateFrom: dateFrom, dateTo: dateTo, page: page, pageSize: pageSize }, (data) => {
                    return data;
                });
            }
            getArbeitszeitnachweis(id) {
                return super.getItem(this.modulePath + '/' + id, {}, (data) => {
                    return data;
                });
            }
            getAllocatableFlsCaseList() {
                return super.get(this.modulePath + '/AllocatableFlsCases', {}, (data) => {
                    return data;
                });
            }
            getArbeitzeitnachweisWv(date) {
                return super.getItem(this.modulePath + '/WvModel', { date }, (data) => {
                    return data;
                });
            }
            getUserConfig(date, aznId) {
                return super.getItem(this.modulePath + '/UserConfig', { date, aznId }, (data) => {
                    return data;
                });
            }
            postArbeitszeitnachweis(data) {
                return super.post(this.modulePath, data).then((e) => {
                    return e;
                });
            }
            putArbeitszeitnachweis(id, data) {
                return super.put(this.modulePath + '/' + id, data).then((e) => {
                    return e;
                });
            }
            deleteArbeitszeitnachweis(id) {
                console.log("LÖSCHEN !!!");
                return super.delete(this.modulePath + '/' + id).then((data) => {
                    return data;
                });
            }
            deleteAllFlsAllocations(aznId) {
                super.delete(this.modulePath + '/' + aznId + '/DeleteAllFlsAllocations');
            }
            checkForWarningsAndErrors(data) {
                return super.getItem(this.modulePath + '/WarningsAndErrors', data, (data) => {
                    return data;
                });
            }
            ///////////////// Workingtime Overview /////////////////
            getWorkingtimeCalculation(date, personId, organisationId, targetView) {
                return super.getItem(this.modulePath + '/WorkingTimeOverview', { date, personId, organisationId, targetView }, (data) => {
                    return data;
                });
            }
            getWorkingTimeOverviewOptions(date, personId) {
                return super.getItem(this.modulePath + '/WorkingTimeOverviewOptions', { date, personId }, (data) => {
                    return data;
                });
            }
            ///////////////////// WeekPlanning /////////////////////
            getAznWeekPlanning(dateFrom, dateTo, showOnlyOwn, showDocumented, personId) {
                return super.get(this.modulePath + '/WeekPlanning', { dateFrom: dateFrom, dateTo: dateTo, showOnlyOwn: showOnlyOwn, showDocumented: showDocumented, personId }, (data) => {
                    return data;
                });
            }
            postAznWeekPlanning(data) {
                if (!Array.isArray(data))
                    data = [data];
                return super.post(this.modulePath + '/WeekPlanning', data).then((e) => {
                    return e;
                });
            }
            putAznWeekPlanning(id, data) {
                return super.put(this.modulePath + '/WeekPlanning/' + id, data).then((e) => {
                    return e;
                });
            }
            deleteAznWeekPlanning(id) {
                return super.delete(this.modulePath + '/WeekPlanning/' + id).then((data) => {
                    return data;
                });
            }
        };
        AznwService = __decorate([
            QMC.Service('QMC.Arbeitszeitnachweis', 'ArbeitszeitnachweisService'),
            QMC.Inject('$http', '$q')
        ], AznwService);
        Arbeitszeitnachweis.AznwService = AznwService;
    })(Arbeitszeitnachweis = QMC.Arbeitszeitnachweis || (QMC.Arbeitszeitnachweis = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Arbeitszeitnachweis;
    (function (Arbeitszeitnachweis) {
        let ArbeitszeitnachweisListController = class ArbeitszeitnachweisListController {
            /**
             * QMC.Arbeitszeitnachweis.AzwnController
             * @constructor
             * @param arbeitszeitnachweisService
             * @param $qui
             * @param $stateParams
             */
            constructor($location, $scope, arbeitszeitnachweisService, $qui, $stateParams, userService, permissionService) {
                this.$location = $location;
                this.$scope = $scope;
                this.arbeitszeitnachweisService = arbeitszeitnachweisService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.userService = userService;
                this.permissionService = permissionService;
                this.allowTableExport = false;
                this.pagination = [];
                this.filter = {
                    dateFrom: moment().startOf('months').toDate(),
                    dateTo: moment().endOf('months').toDate(),
                };
                this.showMonthFilter = true;
                this.showTime = false;
                $qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                this.setTableSchema();
                QMC.Common.personalLocalStorage.removeItem(QMC.Common.LocalStorageConstants.AZN_PREVIOUS_STATE);
                if (document.getElementById("permissions").getAttribute("arbeitszeitnachweis").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module arbeitszeitnachweis");
                    this.forbidden = true;
                    return;
                }
                //ObjectType: ArbeitszeitnachweisPlugin
                this.permissionLoading = true;
                permissionService.getPermissionsByObjectType(425000).then((data) => {
                    // if no permission for module access, return
                    if (!data[0].moduleAccess) {
                        this.forbidden = true;
                        return;
                    }
                    this.delete = data[0].delete && data[0].moduleAccess;
                    this.new = data[0].new && data[0].moduleAccess;
                    this.modify = data[0].modify && data[0].moduleAccess;
                    this.view = data[0].view && data[0].moduleAccess;
                    this.allowTableExport = data[0].print;
                    this.$qui.getTableAutoload(this.userService).then((ltd) => {
                        this.shouldLoadTableData = ltd;
                        this.userService.getUserSettings(["FLS.SHOWMONTHFILTER", "SHOWTIMEINSTEADOFDECIMAL"]).then((data) => {
                            this.showMonthFilter = data[0].value === "" ? QMC.Common.UserSettingConstantsAndDefaults.SHOWMONTHFILTERFLS : data[0].value.toLowerCase() === "true";
                            this.showTime = data[1].value === "" ? QMC.Common.UserSettingConstantsAndDefaults.SHOWTIMEINSTEADOFDECIMAL : data[1].value.toLowerCase() === "true";
                            this.page = 0;
                            if ($stateParams.page !== (undefined || null)) {
                                this.page = Number($stateParams.page);
                            }
                            if (this.shouldLoadTableData) {
                                this.getData();
                                this.init();
                            }
                            // make sure scope gets updated if not already in progress
                            this.$qui.scopeApply(this.$scope);
                        });
                    });
                    this.permissionLoading = false;
                });
            }
            getData() {
                this.setPage(this.page);
            }
            setTableSchema() {
                this.aznTable = {
                    "config": {
                        "tableRowLink": "#/azn/detail/{{objectId}}",
                    },
                    "table": {
                        "Datum von": {
                            "label": "dateFrom",
                            "withTime": "true",
                            "dType": "Date",
                            "lngTag": "20000047"
                        },
                        "Datum bis": {
                            "label": "dateTo",
                            "withTime": "true",
                            "dType": "Date",
                            "lngTag": "20000054"
                        },
                        "Art": {
                            "label": "type",
                            "dType": "string",
                            "lngTag": "21005005"
                        },
                        "Dauer": {
                            "label": "durationInHours",
                            "dType": "Time",
                            "calculate": "true",
                            "lngTag": "20000075"
                        },
                        "Bezeichnung": {
                            "label": "caption",
                            "dType": "string",
                            "lngTag": "20000053"
                        },
                    }, "card": {
                        "avatar": {
                            "icon": "qm-icon-history2"
                        },
                        "text": {
                            "label": "type",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "dateFrom",
                                "withTime": "true",
                                "dType": "Date"
                            },
                            {
                                "label": "dateTo",
                                "withTime": "true",
                                "dType": "Date"
                            }
                        ],
                        "buttons": {
                            "icon": "qm-icon-pencil blue",
                            "href": "#/azn/detail/{{objectId}}",
                            "label": "data",
                            "dType": "Button",
                            "tooltip": "Bearbeiten",
                            "lngTag": "20000044",
                            "permission": "modify"
                        }
                    },
                    "data": null,
                };
            }
            /**
             * init
             * @description Init the filter
             */
            init() {
                this.filterWatcher = this.$scope.$watchCollection('vm.filter', (newValue, oldValue) => {
                    if (newValue === oldValue)
                        return;
                    console.log('#### filterWatcher');
                    this.getAznList();
                });
            }
            /////////////// DISPLAY LOGIC ///////////////
            /**
             * setPage
             * @description Set the current paginated page
             * @param page The current page
             */
            setPage(page) {
                console.log('#### setPage');
                this.page = page;
                this.getAznList();
            }
            /**
             * setPagination
             * @description Create a Pagination object for the view
             */
            setPagination() {
                console.log('#### setPagination aznListController');
                this.pagination = [];
                for (let i = 1; i <= Number(this.aznList.paginationInfo.totalPages); i++) {
                    this.pagination.push(i);
                }
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * getAznList()
             * @description Get the azn list by a date range from API
             */
            /*private abc : any;*/
            getAznList() {
                console.log('### getAZNList');
                this.loading = true;
                this.arbeitszeitnachweisService.getArbeitszeitnachweisList(this.filter.dateFrom, this.filter.dateTo).then((data) => {
                    this.aznTable.data = data.items;
                    this.$qui.functionWaiter("createTable", this);
                    this.loading = false;
                });
            }
        };
        ArbeitszeitnachweisListController = __decorate([
            QMC.Controller('QMC.Arbeitszeitnachweis', 'ArbeitszeitnachweisListController'),
            QMC.Inject('$location', '$scope', 'ArbeitszeitnachweisService', '$qui', '$stateParams', 'UserService', 'QmcPermissionService')
        ], ArbeitszeitnachweisListController);
    })(Arbeitszeitnachweis = QMC.Arbeitszeitnachweis || (QMC.Arbeitszeitnachweis = {}));
})(QMC || (QMC = {}));
/// <reference path="../../../QMC.Web.Fachleistung/AppScripts/Fachleistung/fachleistung.ui.ts" />
var QMC;
(function (QMC) {
    var Arbeitszeitnachweis;
    (function (Arbeitszeitnachweis) {
        let ArbeitszeitnachweisNewController = class ArbeitszeitnachweisNewController {
            constructor($location, arbeitszeitnachweisService, $qui, $scope, $state, $timeout, identityService, userService, lng, permissionService) {
                this.$location = $location;
                this.arbeitszeitnachweisService = arbeitszeitnachweisService;
                this.$qui = $qui;
                this.$scope = $scope;
                this.$state = $state;
                this.$timeout = $timeout;
                this.identityService = identityService;
                this.userService = userService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.BREAK_WV = '6bcdeacd-55a6-476c-9ad5-25af60eb88b6';
                this.caseSearchText = "";
                this.disable = true;
                this.caseFilter = QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_DEFAULTS;
                this.saving = false;
                this.defaultActivity = QMC.Common.Constants.DEFAULT_ACTIVITY_ID;
                this.casesToShow = [];
                this.loadingUserConfig = true;
                this.orgImpute = false;
                this.timeFormSchema = {
                    form: [
                        {
                            placeholder: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            type: "DateRange",
                            startDate: null,
                            endDate: null,
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo",
                                durationInHours: "durationInHours"
                            },
                            style: {
                                class: "col-xs-12 col-md-12"
                            },
                            config: {
                                displayDateTo: true,
                                displayTime: true,
                                dateToRequired: true,
                                roundInterval: 0,
                                startRoundType: null,
                                endRoundType: null,
                                disableTime: "isManualDuration",
                            }
                        },
                        {
                            label: "Dauer",
                            model: "timeString",
                            lngTag: 20000075,
                            type: "String",
                            disabled: true,
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-clock-o"
                            },
                            events: {
                                hide: "isManualDuration"
                            }
                        },
                        {
                            label: "Stunden",
                            model: "hours",
                            type: "Number",
                            style: {
                                class: "col-xs-6 col-md-3"
                            },
                            events: {
                                hideExpression: "!(qmForm.isManualDuration)"
                            }
                        },
                        {
                            label: "Minuten",
                            type: "Number",
                            model: "minutes",
                            style: {
                                class: "col-xs-6 col-md-3"
                            },
                            events: {
                                hideExpression: "!(qmForm.isManualDuration)"
                            }
                        },
                        {
                            label: "Manuelle Dauer",
                            type: "Checkbox",
                            lngTag: 20000213,
                            model: "isManualDuration",
                            id: "isManualDuration",
                            style: {
                                class: "col-lg-4 col-xs-12 col-md-12"
                            },
                            events: {
                                hideExpression: "!(qmScopeCallback().isManualDuration) && !(qmForm.isManualTimeAllowed)"
                            }
                        }
                    ]
                };
                this.commentFormSchema = {
                    form: [
                        {
                            label: "Bemerkung",
                            type: "Summernote",
                            lngTag: "20000049",
                            model: "comment",
                            style: {
                                class: "col-xs-12",
                            }
                        }
                    ]
                };
                $qui.init($qui.getSectionColor("/azn"), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                if (document.getElementById("permissions").getAttribute("arbeitszeitnachweis").toLocaleLowerCase() !== "true") {
                    this.forbidden = true;
                    return;
                }
                const previousStateCache = QMC.Common.personalLocalStorage.getItem(QMC.Common.LocalStorageConstants.AZN_PREVIOUS_STATE);
                if (previousStateCache !== null) {
                    this.returnState = JSON.parse(previousStateCache);
                }
                else {
                    this.returnState = {
                        state: "azn",
                        params: []
                    };
                }
                QMC.Common.personalLocalStorage.removeItem(QMC.Common.LocalStorageConstants.AZN_PREVIOUS_STATE);
                //ObjectType: ArbeitszeitnachweisPlugin
                permissionService.getPermissionsByObjectTypes([425000, 411011]).then((data) => {
                    this.deletePermission = data[0].delete && data[0].moduleAccess;
                    this.new = data[0].new && data[0].moduleAccess;
                    this.modify = data[0].modify && data[0].moduleAccess;
                    this.view = data[0].view && data[0].moduleAccess;
                    this.allocationPermissions = {
                        delete: data[1].delete && data[1].moduleAccess,
                        modify: data[1].modify && data[1].moduleAccess,
                        new: data[1].new && data[1].moduleAccess,
                        view: data[1].view && data[1].moduleAccess
                    };
                });
                this.formState = 'new';
                this.cases = [];
                this.userService.getUserSettings(["FLS.DEFAULTACTIVITYTYPE"], false).then((data) => {
                    var _a;
                    if (((_a = data[0].value) === null || _a === void 0 ? void 0 : _a.length) && data[0].value !== QMC.Common.Constants.GUID_EMPTY)
                        this.defaultActivity = data[0].value;
                }).finally(() => {
                    this.edit = this.$state.params.hasOwnProperty('id');
                    this.initForm();
                    if (this.edit) {
                        this.edit = true;
                        this.clientId = this.$state.params.id;
                        this.loading = true;
                        this.getDetailData(this.$state.params.id);
                    }
                    else {
                        this.initTime();
                        this.events();
                    }
                });
                this.userService.getUserSettings(["AZN.SHOWDATETO", "SHOWTIMEINSTEADOFDECIMAL", QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_KEY]).then((data) => {
                    this.dateToEnabled = data[0].value.toLowerCase() === "true";
                    this.showTime = data[1].value.toLowerCase() === "true";
                    this.timeFormSchema.form[0].config.displayDateTo = this.dateToEnabled;
                    this.caseFilter = data[2].value === '' ? this.caseFilter : JSON.parse(data[2].value);
                    this.getAlloCaseList();
                });
                this.promptOptions = {
                    title: "Arbeitszeitnachweis",
                    icon: "qm-icon-history2",
                    text: this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?'),
                };
            }
            events() {
                this.$qui.functionWaiter("createForm", this);
                this.$qui.functionWaiter("createCommentForm", this);
                this.$scope.$watch('vm.timeForm.dateFrom', (newVal, oldVal) => {
                    if (moment(newVal).format('L') !== moment(oldVal).format('L'))
                        this.getAznWvList();
                    this.validate();
                });
                this.$scope.$watch('vm.timeForm.dateTo', () => {
                    this.validate();
                });
                this.$scope.$watch('vm.form.typeWvId', () => {
                    if (this.form.typeWvId === this.BREAK_WV)
                        this.form.isImpute = false;
                    else {
                        this.form.isImpute = this.form.isImpute || this.orgImpute;
                    }
                    this.validate();
                });
                this.$scope.$watch('vm.form.activityId', () => {
                    this.validate();
                });
                this.$scope.$watch('vm.form.instituteId', () => {
                    this.validate();
                });
                this.$scope.$watch('vm.form.isImpute', () => {
                    this.validate();
                });
                this.$scope.$watch('vm.form.reasonWvId', (newVal, oldVal) => {
                    if (newVal === oldVal || !this.form.isReasonRequired)
                        return;
                    this.validate();
                });
                this.$scope.$watch('vm.timeForm.durationInHours', () => {
                    if (this.showTime) {
                        const conv = this.$qui.convertDec(this.timeForm.durationInHours);
                        let minutes = conv[1].toString();
                        if (conv[1] < 10)
                            minutes = "0" + minutes;
                        this.timeForm.timeString = conv[0] + ":" + minutes;
                    }
                    else {
                        if (this.timeForm.durationInHours) {
                            this.timeForm.timeString = this.timeForm.durationInHours.toFixed(2).toString().replace('.', ',');
                        }
                    }
                });
                this.$scope.$watch('vm.timeForm.isManualDuration', () => {
                    if (this.clearTimeIfDurationIsManuell) {
                        if (this.timeForm.isManualDuration) {
                            const tmp = this.$qui.convertDec(this.timeForm.durationInHours);
                            this.timeForm.dateFrom = moment(this.timeForm.dateFrom).startOf('day').toDate();
                            this.timeForm.dateTo = moment(this.timeForm.dateTo).startOf('day').toDate();
                            setTimeout(() => {
                                this.timeForm.hours = tmp[0];
                                this.timeForm.minutes = tmp[1];
                            });
                        }
                        else if (!this.timeForm.isManualDuration) {
                            this.timeForm.dateFrom = moment(this.timeForm.dateFrom).set('hour', this.form.defaultHour).toDate();
                            this.timeForm.dateTo = moment(this.timeForm.dateTo)
                                .set('hour', this.form.defaultHour + this.timeForm.hours)
                                .set('minute', this.timeForm.minutes)
                                .toDate();
                        }
                    }
                });
                this.$scope.$watch('vm.timeForm.hours', (newVal, oldVal) => {
                    if (newVal === oldVal)
                        return;
                    this.manualTimeWatch();
                }, true);
                this.$scope.$watch('vm.timeForm.minutes', (newVal, oldVal) => {
                    if (newVal === oldVal)
                        return;
                    this.manualTimeWatch();
                }, true);
            }
            manualTimeWatch() {
                if (!this.timeForm.isManualDuration)
                    return;
                let hours = this.cleanInputNumber(this.timeForm.hours);
                let minutes = this.cleanInputNumber(this.timeForm.minutes);
                while (minutes >= 60) {
                    minutes = minutes - 60;
                    hours = hours + 1;
                }
                this.timeForm.hours = hours;
                this.timeForm.minutes = minutes;
                //this.validate(); //commented since azn currently dont validate manual time, so dont bother the server
            }
            cleanInputNumber(inputNumber) {
                //remove commas and leading minus characters and
                //possibility to remove content of input box completely
                if (isNaN(inputNumber)) {
                    inputNumber = 0;
                }
                //kill leading zeros
                inputNumber = +inputNumber;
                return Math.round(inputNumber);
            }
            /**
             * Init the form, set default properties.
             *
             * @private
             *
             * @memberOf ArbeitszeitnachweisNewController
             */
            initForm() {
                this.form = {
                    //dateFrom: moment().hours(8).minutes(0).toDate(),
                    //dateTo: moment().hours(8).minutes(0).toDate(),
                    durationInHours: null,
                    kuerzel: this.lng.translate(21005000, "Arbeitszeitnachweis").charAt(0),
                    caption: this.lng.translate(21005000, "Arbeitszeitnachweis"),
                    organizationObjectId: QMC.Common.Constants.GUID_EMPTY,
                    activityId: this.defaultActivity,
                    typeWvId: QMC.Common.Constants.GUID_EMPTY,
                    imputeWvId: QMC.Common.Constants.GUID_EMPTY,
                    isImpute: false,
                    reasonWvId: QMC.Common.Constants.GUID_EMPTY,
                    flsAllocations: [],
                    isManualDuration: false,
                    minimalStartHour: 0,
                    maximalStartHour: 0,
                    timeSetMinuteInterval: 0,
                    startRoundType: 0,
                    endRoundType: 0,
                    hasStartHourRounding: false,
                    hasEndHourRound: false,
                    defaultHour: 0,
                    isManualTimeAllowed: true,
                    comment: "",
                    isActivityStandardValidValue: QMC.Common.Constants.GUID_EMPTY,
                    isReasonRequired: false,
                    isCareTypeRequiered: false,
                    isContactTypeRequiered: false,
                    fixActivityId: QMC.Common.Constants.GUID_EMPTY,
                    performingPersonObjectId: $('#session').data().personId
                };
                this.form.flsAllocations.watcherList = [];
                this.timeForm = {
                    //dateFrom: this.form.dateFrom,
                    //dateTo: this.form.dateTo,
                    hours: 0,
                    minutes: 0,
                    isManualDuration: false,
                    isManualTimeAllowed: true
                };
                this.initTime();
                if (!this.edit)
                    this.getAznWvList();
            }
            initTime() {
                this.form.dateTo = moment().minutes(0).toDate();
                this.form.dateTo.setSeconds(0);
                this.form.dateTo.setMilliseconds(0);
                this.form.dateFrom = moment().minutes(0).toDate();
                this.form.dateFrom.setHours(this.form.dateFrom.getHours() - 1);
                this.timeForm.dateFrom = this.form.dateFrom;
                this.timeForm.dateTo = this.form.dateTo;
            }
            convertDate(dateFrom, dateTo) {
                if (dateTo < dateFrom)
                    dateFrom = [dateTo, dateTo = dateFrom][0];
                return [dateFrom, dateTo];
            }
            addToList(object) {
                if (this.form.flsAllocations === null) {
                    this.form.flsAllocations = [];
                    this.form.flsAllocations.watcherList = [];
                }
                object.percentShare = 0;
                this.form.flsAllocations.push(object);
                this.removeFromListById(object.flsCaseId);
                const index = this.form.flsAllocations.length - 1;
                this.form.flsAllocations.watcherList.push(this.$scope.$watch('vm.form.flsAllocations[' + index + '].percentShare', (newValue, oldValue) => {
                    if (newValue !== oldValue)
                        this.validate();
                }));
                this.devideShares();
            }
            removeFromList(object) {
                for (let i = 0; i < this.form.flsAllocations.length; i++) {
                    if (this.form.flsAllocations[i].flsCaseId === object.flsCaseId) {
                        this.form.flsAllocations.splice(i, 1);
                    }
                }
                this.cases.push(object);
                this.devideShares();
            }
            enableAllocationEdit() {
                if (this.formState === 'edit') {
                    return this.allocationPermissions.modify;
                }
                else if (this.formState === 'new') {
                    return this.allocationPermissions.new;
                }
            }
            showAllocation() {
                return this.showFlsAllocation && ((this.formState === 'new' && this.allocationPermissions.new) || (this.formState === 'edit' && this.allocationPermissions.view));
            }
            getUserConfig() {
                this.arbeitszeitnachweisService.getArbeitszeitnachweisRequiredFields().then(data => {
                    this.form.isReasonRequired = data.reasonWvId;
                });
                this.arbeitszeitnachweisService.getUserConfig(this.timeForm.dateFrom, this.form.objectId).then((data) => {
                    const tmp = {
                        form: { ...this.form },
                        timeForm: { ...this.timeForm }
                    };
                    if (this.formState !== 'edit')
                        tmp.form.isImpute = data.anrechnenDefaultValue === QMC.Common.Constants.WV_YES;
                    this.orgImpute = tmp.form.isImpute;
                    this.isAnrechnenEditable = data.isAnrechnenEditable;
                    this.clearTimeIfDurationIsManuell = data.clearTimeIfDurationIsManuell;
                    this.showFlsAllocation = data.showFlsAllocation;
                    tmp.form.isManualTimeAllowed = data.isManualTimeAllowed;
                    //override the isManualDuration when you create a new azn with isManualTimeAllowed
                    tmp.form.isManualDuration = tmp.form.isManualTimeAllowed;
                    tmp.timeForm.isManualTimeAllowed = data.isManualTimeAllowed;
                    tmp.form.isActivityStandardValidValue = data.isActivityStandardValidValue;
                    tmp.form.isCareTypeRequiered = data.isCareTypeRequiered;
                    tmp.form.isContactTypeRequiered = data.isContactTypeRequiered;
                    tmp.form.fixActivityId = data.fixActivityId;
                    if (data.fixActivityId && data.fixActivityId !== QMC.Common.Constants.GUID_EMPTY) {
                        tmp.form.activityId = data.fixActivityId;
                    }
                    tmp.form.minimalStartHour = data.minimalStartHour;
                    tmp.form.maximalStartHour = data.maximalStartHour;
                    tmp.form.timeSetMinuteInterval = data.timeSetMinuteInterval;
                    tmp.form.startRoundType = data.startRoundingType;
                    tmp.form.endRoundType = data.endRoundingType;
                    tmp.form.hasStartHourRounding = data.hasStartHourRounding;
                    tmp.form.hasEndHourRound = data.hasEndHourRound;
                    tmp.form.defaultHour = data.defaultHour;
                    if (!this.$state.params.hasOwnProperty('id')) {
                        tmp.timeForm.dateFrom.setHours(data.defaultHour);
                        tmp.timeForm.dateFrom.setMinutes(0);
                        tmp.timeForm.dateTo.setHours(data.defaultHour + 1);
                        tmp.timeForm.dateTo.setMinutes(0);
                        this.timeFormSchema.form[0].config.roundInterval = data.hasStartHourRounding || data.hasEndHourRound ? tmp.form.timeSetMinuteInterval : 0;
                        this.timeFormSchema.form[0].config.startRoundType = data.hasStartHourRounding ? tmp.form.startRoundType : null;
                        this.timeFormSchema.form[0].config.endRoundType = data.hasEndHourRound ? tmp.form.endRoundType : null;
                    }
                    this.form = tmp.form;
                    this.timeForm = tmp.timeForm;
                    this.$timeout(() => {
                        if (!this.edit)
                            this.form.instituteId = data.defaultInstituteId;
                    });
                }).finally(() => {
                    this.loadingUserConfig = false;
                    this.validate();
                });
            }
            removeFromListById(id) {
                this.cases = this.cases.filter(y => y.flsCaseId !== id);
            }
            devideShares() {
                const percent = 100 / this.form.flsAllocations.length;
                for (const element of this.form.flsAllocations) {
                    element.percentShare = percent;
                }
            }
            getSharedValue() {
                var _a;
                if (!((_a = this.form) === null || _a === void 0 ? void 0 : _a.flsAllocations))
                    return 100;
                let flsAllocationsValue = 0;
                if (this.form.flsAllocations) {
                    for (const element of this.form.flsAllocations) {
                        flsAllocationsValue += Number(element.percentShare);
                    }
                }
                // round to 5th decimal position
                flsAllocationsValue = Math.round(flsAllocationsValue * 10000) / 10000;
                return Number(flsAllocationsValue.toFixed(5));
            }
            validate() {
                if (this.loadingUserConfig || !this.timeForm.dateFrom || !this.timeForm.dateTo)
                    return;
                if (this.lastValidation && (this.lastValidation.timeForm == JSON.stringify(this.timeForm) && this.lastValidation.form == JSON.stringify(this.form)))
                    return;
                const randomId = this.$qui.generateGuid();
                this.lastValidation = {
                    timeForm: JSON.stringify(this.timeForm),
                    form: JSON.stringify(this.form),
                    randomId
                };
                this.checkLoad = true;
                let dateFrom, dateTo;
                [dateFrom, dateTo] = this.convertDate(this.timeForm.dateFrom, this.timeForm.dateTo);
                this.warnings = { warnings: [], errors: [], isLoading: true };
                const validateParam = {
                    idObjectAznw: this.form.objectId,
                    dateFrom: moment(dateFrom).format(),
                    dateTo: moment(dateTo).format(),
                    performingPersonObjIdList: this.form.performingPersonObjectId,
                    isPlanned: false,
                    activityId: this.form.activityId,
                    imputeWvId: this.form.isImpute ? QMC.Common.Constants.WV_YES : QMC.Common.Constants.WV_NO,
                    instituteId: this.form.instituteId
                };
                this.arbeitszeitnachweisService.checkForWarningsAndErrors(validateParam)
                    .then((data) => {
                    if (randomId !== this.lastValidation.randomId)
                        return;
                    this.warnings = {
                        ...data, isLoading: false
                    };
                    if (this.form.typeWvId === null || this.form.typeWvId === QMC.Common.Constants.GUID_EMPTY)
                        this.warnings.errors.push(this.lng.translate(21005040, "Der Arbeitzeitnachweis benötigt eine Art."));
                    if (this.getSharedValue() !== 100 && this.form.flsAllocations && this.form.flsAllocations.length > 0)
                        this.warnings.warnings.push(this.lng.translate(21005053, "Die Summe aller FLS Zuordnungen ist ungleich 100 Prozent."));
                    if (this.timeForm.dateTo < this.timeForm.dateFrom)
                        this.warnings.errors.push(this.lng.translate(20002004, "Das Startdatum ist größer als das Enddatum."));
                    if (!this.form.instituteId || this.form.instituteId === QMC.Common.Constants.GUID_EMPTY)
                        this.warnings.errors.push(this.lng.translate(21005047, "Es muss ein Erbringungsort angegeben werden."));
                    if (this.form.isReasonRequired && this.form.reasonWvId === QMC.Common.Constants.GUID_EMPTY)
                        this.warnings.errors.push(this.lng.translate(21005054, "Es muss ein Grund angegeben werden."));
                }).catch((e) => {
                    this.warnings = {
                        errors: [e],
                        warnings: [],
                        isLoading: false
                    };
                }).finally(() => {
                    this.checkLoad = false;
                });
            }
            saveThough() {
                $('#validationModal').modal('toggle');
                if ($('.modal-backdrop') !== null)
                    $('.modal-backdrop').remove();
                if (this.edit)
                    this.editAzn();
                else
                    this.postAzn();
            }
            saveAzn() {
                this.form.dateFrom = this.timeForm.dateFrom;
                this.form.dateTo = this.timeForm.dateTo;
                this.form.isManualDuration = this.timeForm.isManualDuration;
                this.form.isManualTimeAllowed = this.timeForm.isManualTimeAllowed;
                this.form.durationInHours = this.convertHours(this.timeForm.hours, this.timeForm.minutes);
                this.form.imputeWvId = this.form.isImpute ? QMC.Common.Constants.WV_YES : QMC.Common.Constants.WV_NO;
                if (this.warnings.warnings.length + this.warnings.errors.length === 0) {
                    if (this.edit)
                        this.editAzn();
                    else
                        this.postAzn();
                }
                else {
                    $('#validationModal').modal('toggle');
                }
            }
            postAzn() {
                if (this.form.typeWvId === QMC.Common.Constants.GUID_EMPTY) {
                    this.$qui.notify({
                        message: this.lng.translate(20002035, "Die Art muss ausgewählt werden!"),
                        title: this.lng.translate(20002015, "Fehler"),
                        icon: "qm-icon-times",
                        status: "warning",
                        timer: 3500
                    });
                    return;
                }
                this.saving = true;
                setTimeout(() => {
                    this.arbeitszeitnachweisService.postArbeitszeitnachweis(this.form).then((data) => {
                        this.$qui.notify(this.$qui.successNote);
                        this.$state.go(this.returnState.state, this.returnState.params);
                    }).finally(() => {
                        this.saving = false;
                    });
                }, 250);
            }
            editAzn() {
                this.form.dateFrom = this.timeForm.dateFrom;
                this.form.dateTo = this.timeForm.dateTo;
                this.form.isManualDuration = this.timeForm.isManualDuration;
                this.form.isManualTimeAllowed = this.timeForm.isManualTimeAllowed;
                this.form.durationInHours = this.convertHours(this.timeForm.hours, this.timeForm.minutes);
                this.saving = true;
                this.arbeitszeitnachweisService.putArbeitszeitnachweis(this.clientId, this.form).then((data) => {
                    this.$qui.notify(this.$qui.successNote);
                    this.$state.reload();
                    this.$state.go(this.returnState.state, this.returnState.params);
                }).finally(() => {
                    this.saving = false;
                });
            }
            delete() {
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data) {
                        this.saving = true;
                        this.arbeitszeitnachweisService.deleteArbeitszeitnachweis(this.form.objectId).then((data) => {
                            this.$qui.notify(this.$qui.deleteNote);
                            this.$state.reload();
                            this.$state.go(this.returnState.state, this.returnState.params);
                        }).finally(() => {
                            this.saving = false;
                        });
                    }
                });
            }
            getAznWvList() {
                this.arbeitszeitnachweisService.getArbeitzeitnachweisWv(this.timeForm.dateFrom).then((data) => {
                    var _a, _b;
                    const previousWv = angular.copy(this.aznWvList);
                    this.aznWvList = data;
                    this.aznTypes = data.types.map((x) => ({ text: x.name, value: x.objectId }));
                    this.reasonTypes = data.reasons.map((x) => ({ text: x.name, value: x.objectId }));
                    this.getUserConfig();
                    this.validate();
                    if (!this.checkIfWvIsPresentById(data.activities, this.form.activityId)) {
                        this.showActivityResetNotification(this.lng.translate(21005004, 'Tätigkeit'), (_b = (_a = previousWv === null || previousWv === void 0 ? void 0 : previousWv.activities.filter(x => x.objectId === this.form.activityId)[0]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '');
                        this.form.activityId = this.checkIfWvIsPresentById(data.activities, this.defaultActivity) ? this.defaultActivity : QMC.Common.Constants.DEFAULT_ACTIVITY_ID;
                    }
                    this.activityMap = this.$qui.selectAutoMap(data.activities, 'objectId', 'name');
                    this.instituteMap = this.$qui.selectAutoMap(data.instituteWvList, 'objectId', 'name');
                });
            }
            showActivityResetNotification(area, caption) {
                this.$qui.notify({
                    message: this.$qui.formatString(this.lng.translate(20016241, 'Die {0} {1} ist an dem Dokumentationsdatum ungültig'), area, caption),
                    title: this.$qui.formatString(this.lng.translate(0, 'Die {0} wurde zurückgesetzt'), area),
                    icon: "qm-icon-information",
                    status: "info",
                    timer: 8000
                });
            }
            checkIfWvIsPresentById(list, id) {
                for (const element of list)
                    if (element.objectId == id)
                        return true;
                return false;
            }
            getAlloCaseList() {
                this.arbeitszeitnachweisService.getAllocatableFlsCaseList().then((data) => {
                    this.cases = data;
                    this.formatAllocatedCases();
                    this.casesToShow = this.currentfilter(this.cases);
                });
            }
            getDetailData(id) {
                this.arbeitszeitnachweisService.getArbeitszeitnachweis(id).then((data) => {
                    this.formState = 'edit';
                    if (!data.activityId || data.activityId === QMC.Common.Constants.GUID_EMPTY)
                        data.activityId = this.defaultActivity;
                    this.form = data;
                    this.loading = false;
                    this.form.dateFrom = this.$qui.createDateFromString(data.dateFrom);
                    this.form.dateTo = this.$qui.createDateFromString(data.dateTo);
                    this.timeForm.dateFrom = this.$qui.createDateFromString(data.dateFrom);
                    this.timeForm.dateTo = this.$qui.createDateFromString(data.dateTo);
                    this.institute = data.organizationName;
                    //override the isManualDuration when you get an azn with isManualTimeAllowed
                    if (!this.timeForm.isManualTimeAllowed) {
                        this.timeForm.isManualDuration = false;
                    }
                    else {
                        this.timeForm.isManualDuration = data.isManualDuration;
                    }
                    const time = this.$qui.convertDec(data.durationInHours);
                    this.timeForm.hours = time[0];
                    this.timeForm.minutes = time[1];
                    this.formatAllocatedCases();
                    this.form.isImpute = this.form.imputeWvId === QMC.Common.Constants.WV_YES;
                    this.orgImpute = this.form.isImpute;
                    this.events();
                    this.getAznWvList();
                });
            }
            formatAllocatedCases() {
                if (this.cases === (null && undefined) || this.form.flsAllocations === (null && undefined))
                    return;
                this.form.flsAllocations = this.form.flsAllocations.map(x => ({ ...x, ...this.cases.filter(y => y.billingRateObjectId === x.billingRateObjectId)[0] }));
                this.cases = this.cases.filter(x => !this.form.flsAllocations.some(y => y.billingRateObjectId === x.billingRateObjectId));
                this.form.flsAllocations.watcherList = [];
                for (let i = 0; i < this.form.flsAllocations; i++) {
                    this.form.flsAllocations.watcherList.push(this.$scope.$watch('vm.form.flsAllocations[' + i + '].percentShare', (newValue, oldValue) => {
                        if (newValue !== oldValue)
                            this.validate();
                    }));
                }
            }
            /**
            * currentFilter
            * @description Returns the current Filter
            * @param entry
            */
            currentfilter(list) {
                return list.filter((x) => x.isCurrent || !this.caseFilter.onlyCurrentCases);
            }
            async toggleShowCurrentOnly() {
                await this.userService.setUserSettings({ settings: [{ key: QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_KEY, value: JSON.stringify(this.caseFilter) }] });
                this.casesToShow = this.currentfilter(this.cases);
                this.$qui.scopeApply(this.$scope);
            }
            convertHours(hours, minutes) {
                return moment.duration(hours + ":" + minutes).asHours();
            }
        };
        ArbeitszeitnachweisNewController = __decorate([
            QMC.Controller('QMC.Arbeitszeitnachweis', 'ArbeitszeitnachweisNewController'),
            QMC.Inject('$location', 'ArbeitszeitnachweisService', '$qui', '$scope', '$state', '$timeout', 'QmcIdentityService', 'UserService', 'QmcLanguageService', 'QmcPermissionService')
        ], ArbeitszeitnachweisNewController);
    })(Arbeitszeitnachweis = QMC.Arbeitszeitnachweis || (QMC.Arbeitszeitnachweis = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Arbeitszeitnachweis;
    (function (Arbeitszeitnachweis) {
        let ArbeitszeitnachweisOverviewController = class ArbeitszeitnachweisOverviewController {
            /**
             * QMC.Arbeitszeitnachweis.AzwnController
             * @constructor
             * @param arbeitszeitnachweisService
             * @param $qui
             * @param $stateParams
             */
            constructor($location, $qui, timeTrackingService, $scope, permissionService) {
                this.timeTrackingService = timeTrackingService;
                this.$scope = $scope;
                this.permissionService = permissionService;
                this.displayTimeTrackingComponent = false;
                this.forbidden = false;
                $qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                this.permissionService.getPermissionsByObjectTypes([120030]).then((data) => {
                    this.forbidden = !data[0].moduleAccess;
                });
                const parentScope = this.$scope.$parent;
                parentScope.overviewChild = this.$scope;
                this.tryGetLatestTimeStampItem();
            }
            tryGetLatestTimeStampItem() {
                this.timeTrackingService.checkTimeTrackingAvailable().then((data) => {
                    if (data.isTimetrackingEnabled) {
                        this.displayTimeTrackingComponent = true;
                        this.getTimeStamp();
                    }
                });
            }
            getTimeStamp() {
                this.timeTrackingService.getLatestTimeTrackingDetailItem().then((item) => {
                    this.latestTimeStamp = item.timeStamp;
                    if (item.punchStatusId.toUpperCase() === Arbeitszeitnachweis.TimeTrackingConstants.TIME_TRACKING_STAMP_IN) {
                        this.isCurrentlyTracking = true;
                        this.refreshWidget(false);
                    }
                    else {
                        this.isCurrentlyTracking = false;
                        this.refreshWidget(true);
                    }
                });
            }
            stopTimeTracking(comment) {
                this.timeTrackingService.postTimeTrackingStop(comment).then(() => {
                    console.log("time tracking has been stopped...");
                    this.getTimeStamp();
                });
            }
            startTimeTracking(comment) {
                this.timeTrackingService.postTimeTrackingStart(comment).then(() => {
                    console.log("time tracking has been started...");
                    this.getTimeStamp();
                });
            }
            refreshWidget(didStampOut) {
                this.$scope.$$childHead.$root.refreshWidget(didStampOut);
            }
        };
        ArbeitszeitnachweisOverviewController = __decorate([
            QMC.Controller('QMC.Arbeitszeitnachweis', 'ArbeitszeitnachweisOverviewController'),
            QMC.Inject('$location', '$qui', 'TimeTrackingService', '$scope', 'QmcPermissionService')
        ], ArbeitszeitnachweisOverviewController);
    })(Arbeitszeitnachweis = QMC.Arbeitszeitnachweis || (QMC.Arbeitszeitnachweis = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Arbeitszeitnachweis;
    (function (Arbeitszeitnachweis) {
        let WorktimeOverviewDirective = class WorktimeOverviewDirective {
            constructor(arbeitszeitnachweisService, $qui, permissionService, userService, lng, $filter) {
                this.arbeitszeitnachweisService = arbeitszeitnachweisService;
                this.$qui = $qui;
                this.permissionService = permissionService;
                this.userService = userService;
                this.lng = lng;
                this.$filter = $filter;
                this.restrict = 'AE';
                this.templateUrl = './Arbeitszeitnachweis/WorktimeOverviewDirective';
                this.scope = {
                    personId: '=?',
                    date: '=?',
                    organisationId: '=?',
                    timeFormattingStyle: '=?',
                    targetView: '=?'
                };
                this.controller = ['$scope', (scope) => {
                        this.$scope = scope;
                        scope.loading = true;
                        this.userService.getUserSettings(["SHOWTIMEINSTEADOFDECIMAL"]).then((data) => {
                            scope.showTime = data[0].value === "" ? QMC.Common.UserSettingConstantsAndDefaults.SHOWTIMEINSTEADOFDECIMAL : data[0].value.toLowerCase() === "true";
                        });
                        this.arbeitszeitnachweisService.getWorkingTimeOverviewOptions(new Date(), $('#session').data().personId).then((data) => {
                            this.$scope.workingtimeSettings = data;
                            scope.supportedViewsMap = data.supportedTargetViews.map(x => ({ text: x.text, value: x.id + '' }));
                        });
                        const setupConf = () => {
                            var _a, _b, _c;
                            scope.conf = {
                                date: (_a = scope.date) !== null && _a !== void 0 ? _a : moment().add('day', -1).toDate(),
                                person: (_b = scope.personId) !== null && _b !== void 0 ? _b : $('#session').data().personId,
                                organisation: scope.organisationId,
                                targetView: (_c = scope.targetView) !== null && _c !== void 0 ? _c : '0'
                            };
                        };
                        scope.$watch('date', () => { setupConf(); }, true);
                        scope.$watch('personId', () => { setupConf(); scope.workingtimeData = undefined; }, true);
                        setupConf();
                        this.getCalculation();
                        scope.organisationTabChange = (organisationId) => {
                            scope.conf.organisation = organisationId;
                        };
                        scope.formatCaption = (item, isFirstElement) => {
                            if (isFirstElement)
                                return item.caption;
                            else if (item.isSummaryItem)
                                return "= " + item.caption;
                            else if (item.isNegative)
                                return "- " + item.caption;
                            else
                                return "+ " + item.caption;
                        };
                        scope.formatTime = (number) => {
                            if (scope.showTime) {
                                let hours = Math.floor(Math.abs(number));
                                let minutes = Math.round(Math.abs(number * 60 % 60));
                                if (minutes < 10)
                                    minutes = "0" + minutes;
                                if (minutes > 59) {
                                    minutes = "00";
                                    hours++;
                                }
                                return (number < 0 ? '-' : '') + hours + ":" + minutes;
                            }
                            else {
                                return this.$filter('number')(number, 2);
                            }
                        };
                        scope.formatWorktimeTooltip = (item, propertyName) => {
                            if ((item === null || item === void 0 ? void 0 : item.detailItems) === null)
                                return "";
                            let toolTip = "";
                            item.detailItems.forEach(detail => toolTip += detail.caption + ": " + scope.formatTime(detail[propertyName]) + "\r\n");
                            return toolTip;
                        };
                        scope.createThresholdTooltip = (item) => {
                            if (!item)
                                return '';
                            return [`${this.lng.translate(20030007, 'Oberer positiver Grenzwert')}: ${scope.formatTime(item.positiveUpperThreshold)}`,
                                `${this.lng.translate(20030008, 'Unterer positiver Grenzwert')}: ${scope.formatTime(item.positiveLowerThreshold)}`,
                                `${this.lng.translate(20030009, 'Oberer negativer Grenzwert')}: ${scope.formatTime(item.negativeUpperThreshold)}`,
                                `${this.lng.translate(20030010, 'Unterer negativer Grenzwert')}: ${scope.formatTime(item.negativeLowerThreshold)}`].join('\r\n');
                        };
                    }];
                this.link = (scope) => {
                    scope.$watch('conf', (oldVal, newVal) => {
                        if (JSON.stringify(oldVal) !== JSON.stringify(newVal))
                            this.getCalculation();
                    }, true);
                };
            }
            getCalculation() {
                this.$scope.loading = true;
                this.arbeitszeitnachweisService.getWorkingtimeCalculation(this.$scope.conf.date, this.$scope.conf.person, this.$scope.conf.organisation, parseInt(this.$scope.conf.targetView))
                    .then((data) => {
                    this.$scope.workingtimeData = data;
                    this.$scope.loading = false;
                    // set traffic light
                    setTimeout(() => {
                        switch (this.$scope.workingtimeData.overtime.status) {
                            case 1:
                                $('#signalLight').removeClass('red');
                                $('#signalLight').addClass('yellow');
                                $('#signalLight').removeClass('green');
                                break;
                            case 2:
                                $('#signalLight').removeClass('red');
                                $('#signalLight').removeClass('yellow');
                                $('#signalLight').addClass('green');
                                break;
                            default:
                                $('#signalLight').addClass('red');
                                $('#signalLight').removeClass('yellow');
                                $('#signalLight').removeClass('green');
                                break;
                        }
                    });
                });
            }
        };
        WorktimeOverviewDirective = __decorate([
            QMC.Directive('QMC.Arbeitszeitnachweis', 'qmWorktimeOverview', ['ArbeitszeitnachweisService', '$qui', 'QmcPermissionService', 'UserService', 'QmcLanguageService', '$filter'])
        ], WorktimeOverviewDirective);
    })(Arbeitszeitnachweis = QMC.Arbeitszeitnachweis || (QMC.Arbeitszeitnachweis = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Arbeitszeitnachweis;
    (function (Arbeitszeitnachweis) {
        let ManualOvertimeService = class ManualOvertimeService extends QMC.Common.BaseService {
            constructor($http, $q) {
                super($http, $q);
                this.$http = $http;
                this.$q = $q;
                this.modulePath = '/ManualOvertime';
            }
            getOvertimeWv() {
                return super.getItem(this.modulePath + '/WvModel', {}, (data) => {
                    return data;
                });
            }
            getManualOvertimeList(contractId, dateFrom, dateTo) {
                return super.getPagination(this.modulePath, { contractId: contractId, dateFrom: dateFrom, dateTo: dateTo }, (data) => {
                    return data;
                });
            }
            getSingleManualOvertimeList(id) {
                return super.getPagination(this.modulePath + '/' + id, {}, (data) => {
                    return data;
                });
            }
            postManualOvertime(data) {
                return super.post(this.modulePath, data).then((e) => {
                    return e;
                });
            }
            putManualOvertime(id, data) {
                return super.put(this.modulePath + '/' + id, data).then((e) => {
                    return e;
                });
            }
            deleteManualOvertime(id) {
                return super.delete(this.modulePath + '/' + id).then((data) => {
                    return data;
                });
            }
        };
        ManualOvertimeService = __decorate([
            QMC.Service('QMC.Arbeitszeitnachweis', 'ManualOvertimeService'),
            QMC.Inject('$http', '$q')
        ], ManualOvertimeService);
        Arbeitszeitnachweis.ManualOvertimeService = ManualOvertimeService;
    })(Arbeitszeitnachweis = QMC.Arbeitszeitnachweis || (QMC.Arbeitszeitnachweis = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Arbeitszeitnachweis;
    (function (Arbeitszeitnachweis) {
        let ManualOvertimeListController = class ManualOvertimeListController {
            /**
             * QMC.ManualOvertime.List.Controller
             * @constructor
             * @param manualovertimeService
             * @param $qui
             * @param $stateParams
             */
            constructor($location, $scope, manualovertimeService, arbeitszeitnachweisService, $qui, $stateParams, userService, permissionService, $timeout) {
                this.$location = $location;
                this.$scope = $scope;
                this.manualovertimeService = manualovertimeService;
                this.arbeitszeitnachweisService = arbeitszeitnachweisService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.userService = userService;
                this.permissionService = permissionService;
                this.$timeout = $timeout;
                this.ui = new Arbeitszeitnachweis.UserInterfaceOvertime();
                this.allowTableExport = false;
                this.loadingWt = true;
                this.filter = {
                    dateFrom: moment().startOf('months').toDate(),
                    dateTo: moment().endOf('months').toDate(),
                };
                this.showMonthFilter = true;
                $qui.init($qui.getSectionColor("/azn/overview"), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                //ObjectType: ÜberstundenManuell
                permissionService.getPermissionsByObjectTypes([890005, 890007]).then((data) => {
                    this.delete = data[0].delete && data[0].moduleAccess;
                    this.new = data[0].new && data[0].moduleAccess;
                    this.modify = data[0].modify && data[0].moduleAccess;
                    this.modifyPermission = data[0].modify && data[0].moduleAccess;
                    this.view = data[0].view && data[0].moduleAccess;
                    this.canApprove = data[1].openFile;
                    this.allowTableExport = data[0].print;
                    this.getOvertimeList();
                    this.getCalculation();
                    this.init();
                    this.events();
                });
            }
            /**
             * init
             * @description Init the filter
             */
            init() {
                this.filterWatcher = this.$scope.$watchCollection('vm.filter', (newValue, oldValue) => {
                    if (newValue === oldValue)
                        return;
                    this.getOvertimeList();
                });
                this.formState = "new";
                this.form = {
                    contractId: null,
                    date: new Date(),
                    reasonId: null,
                    approvedId: this.canApprove ? 'a8d072b9-8cdb-4e91-810b-df609c6946c3' : 'efd58886-58e4-4562-adcb-27e677167767',
                    approvedPersonId: null,
                    comment: "",
                    hours: 0,
                    canApprove: !this.canApprove,
                    objectId: null
                };
            }
            events() {
                this.filterWatcher = this.$scope.$watchCollection('vm.filter', (newValue, oldValue) => {
                    if (newValue === oldValue)
                        return;
                    this.getOvertimeList();
                });
            }
            addOvertime() {
                this.loading = true;
                this.manualovertimeService.postManualOvertime(this.form).then((data) => {
                    this.ui.notify(this.ui.successNote);
                    this.getOvertimeList();
                    this.formState = "new";
                    this.getCalculation();
                    this.loading = false;
                }).catch(() => { this.loading = false; });
            }
            editOvertime(input) {
                this.manualovertimeService.getSingleManualOvertimeList(input.objectId).then((data) => {
                    this.formState = "edit";
                    this.form = data;
                    this.form.date = this.$qui.createDateFromString(data.date);
                    // do not allow modification of approved times, unless you can approve as well
                    if (data.approvedId !== null && this.form.approvedId.toLowerCase() === QMC.Common.Constants.APPROVAL_APRROVED_ID && !this.canApprove)
                        this.modify = false;
                    else
                        this.modify = this.modifyPermission;
                });
            }
            putOvertime(input) {
                this.loading = true;
                this.manualovertimeService.putManualOvertime(this.form.objectId, this.form).then((data) => {
                    this.ui.notify(this.ui.successNote);
                    this.getOvertimeList();
                    this.formState = "new";
                    this.getCalculation();
                    this.loading = false;
                }).catch(() => { this.loading = false; });
            }
            deleteOvertime(input) {
                this.manualovertimeService.getSingleManualOvertimeList(input.objectId).then((data) => {
                    // do not allow modification of approved times, unless you can approve as well
                    if (data.approvedId !== null && data.approvedId.toLowerCase() === QMC.Common.Constants.APPROVAL_APRROVED_ID && !this.canApprove)
                        return;
                    this.manualovertimeService.deleteManualOvertime(input.objectId).then((data) => {
                        this.ui.notify(this.ui.deleteNote);
                        this.formState = "new";
                        this.getOvertimeList();
                        this.getCalculation();
                    });
                });
            }
            getApprovedWvList() {
                return this.manualovertimeService.getOvertimeWv().then((data) => {
                    return this.ui.select(data.approvedWvList, { value: "objectId", text: "name" });
                });
            }
            getReasonWvList() {
                return this.manualovertimeService.getOvertimeWv().then((data) => {
                    return this.ui.select(data.reasonWvList, { value: "objectId", text: "name" });
                });
            }
            getOvertimeList() {
                /* Deregister Watcher */
                if (this.filterWatcher)
                    this.filterWatcher();
                this.loading = true;
                this.manualovertimeService.getManualOvertimeList(null, this.filter.dateFrom, this.filter.dateTo).then((data) => {
                    for (let i = 0; i < data.length; i++) {
                        data[i].dateString = moment(data[i].date).format("DD.MM.YYYY");
                    }
                    this.ui.overtimeTable.data = data;
                    this.loading = false;
                    this.$timeout(() => {
                        this.$qui.functionWaiter("ui.createForm", this);
                        this.$qui.functionWaiter("ui.createTable", this);
                    });
                });
            }
            getCalculation() {
                this.loadingWt = true;
                let currentDate = new Date();
                currentDate.setHours(23, 59, 59, 999);
                this.arbeitszeitnachweisService.getWorkingtimeCalculation(currentDate).then((data) => {
                    this.workingtimeData = data;
                    this.loadingWt = false;
                    // set traffic light
                    setTimeout(() => {
                        switch (this.workingtimeData.overtime.status) {
                            case 1:
                                $('#red').removeClass('activeLight');
                                $('#yellow').addClass('activeLight');
                                $('#green').removeClass('activeLight');
                                break;
                            case 2:
                                $('#red').removeClass('activeLight');
                                $('#yellow').removeClass('activeLight');
                                $('#green').addClass('activeLight');
                                break;
                            default:
                                $('#red').addClass('activeLight');
                                $('#yellow').removeClass('activeLight');
                                $('#green').removeClass('activeLight');
                                break;
                        }
                    }, 500);
                });
            }
        };
        ManualOvertimeListController = __decorate([
            QMC.Controller('QMC.Arbeitszeitnachweis', 'ManualOvertimeListController'),
            QMC.Inject('$location', '$scope', 'ManualOvertimeService', 'ArbeitszeitnachweisService', '$qui', '$stateParams', 'UserService', 'QmcPermissionService', '$timeout')
        ], ManualOvertimeListController);
    })(Arbeitszeitnachweis = QMC.Arbeitszeitnachweis || (QMC.Arbeitszeitnachweis = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Arbeitszeitnachweis;
    (function (Arbeitszeitnachweis) {
        /**
         * Stammdaten UserInterface class
         *
         * @export
         * @class UserInterface
         * @extends {Common.UserInterface}
         */
        class UserInterfaceOvertime extends QMC.Common.UserInterface {
            constructor() {
                super(...arguments);
                /**
                 * Medicament table
                 * @memberOf UserInterface
                 */
                this.overtimeTable = {
                    "config": {
                        "defaultSort": "date",
                        "sortReverse": "false",
                    },
                    "table": {
                        "Datum": {
                            "label": "date",
                            "dType": "Date",
                            "lngTag": "20000045"
                        },
                        "Dauer": {
                            "label": "hours",
                            "dType": "Number",
                            "lngTag": "20000075"
                        },
                        "Grund": {
                            "label": "reason",
                            "dType": "string",
                            "lngTag": "20000285"
                        },
                        "Genehmigt": {
                            "label": "approved",
                            "dType": "string",
                            "lngTag": "20027003"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editOvertime",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "openModal": "true",
                                "targetModal": "#overtimeModal",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteOvertime",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    }, "card": {
                        "avatar": {
                            "icon": "qm-icon-history2"
                        },
                        "text": {
                            "label": "dateString",
                            "dType": "string",
                        },
                        "subtext": [
                            {
                                "label": "hours",
                                "dType": "Number"
                            },
                            {
                                "label": "reason",
                                "dType": "string"
                            },
                            {
                                "label": "approved",
                                "dType": "string"
                            }
                        ],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "openModal": "true",
                                "targetModal": "#overtimeModal",
                                "click": "editOvertime",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteOvertime",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                this.overtimeForm = {
                    form: [{
                            placeholder: "Datum",
                            label: "Datum",
                            type: "Date",
                            lngTag: 20000045,
                            model: "date",
                            required: true,
                            validate: {
                                message: "Bitte geben Sie ein gültiges Datum ein.",
                                messageTag: 21003015
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            label: "Stunden",
                            type: "Number",
                            minValue: -1000,
                            model: "hours",
                            lngTag: 20000219,
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        },
                        {
                            placeholder: "Grund",
                            label: "Grund",
                            type: "Select",
                            dataSource: "getReasonWvList",
                            model: "reasonId",
                            lngTag: 20000285,
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-question-circle"
                            }
                        }, {
                            placeholder: "Genehmigt",
                            label: "Genehmigt",
                            type: "Select",
                            dataSource: "getApprovedWvList",
                            model: "approvedId",
                            lngTag: 20027003,
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-exclamation-circle"
                            },
                            events: {
                                hide: "canApprove"
                            }
                        },
                        {
                            placeholder: "Bemerkung eintragen ...",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            model: "comment",
                            lngTag: 20000049,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12 col-md-12",
                            }
                        },],
                    actions: {
                        put: "putOvertime",
                        post: "addOvertime",
                    }
                };
            }
        }
        Arbeitszeitnachweis.UserInterfaceOvertime = UserInterfaceOvertime;
    })(Arbeitszeitnachweis = QMC.Arbeitszeitnachweis || (QMC.Arbeitszeitnachweis = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/Arbeitszeitnachweis/qmc.arbeitszeitnachweis.js.map
